import React, { useState, useEffect, useRef } from 'react';
import RagnaWindow from '../ReactComponents/RagnaWindow.jsx';
import { RMultiTab } from '../ReactComponents/RMultiTab.jsx';
import RagnaLoader from '../ReactComponents/RagnaLoader.jsx';
import { RDatePicker } from '../ReactComponents/RDatePicker.jsx';
import RagnaModal from '../ReactComponents/RagnaModal.jsx';
import { s2ab, canBeViewedWeb } from '../ReactGlobals.js';
import { ajax_api, _basename, ocr } from '../../Globals.jsx';
import moment from 'moment';
import axios from 'axios';
import Select from 'react-select';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { createWorker } from 'tesseract.js';
import { Document, Page, pdfjs } from 'react-pdf';
import { Helmet } from 'react-helmet';
import RichTextEditor from '../ReactComponents/RichTextEditor.jsx';
import { stripHtml } from "string-strip-html";

pdfjs.GlobalWorkerOptions.workerSrc = _basename + 'plugins/pdfjs/pdf.worker.js';



const SPItemAdd = props => {
    const SAVE_URL = ajax_api + "items/" + (props.editMode ? "edit" : "save");
    let navigate = useNavigate();
    const [numPages, setNumPages] = useState(0);
    const [currentPdfPage, setCurrentPdfPage] = useState(1);
    //const codeAuthor = [{ value: -1, display: "-" }, ...props.codeOfficial];
    //const codeCoAuthor = [...props.codeOfficial];
    //const { codeItemType, codeSession, codeCouncil, codeCommittee, codeCategory } = props;

    const [codeItemType, setCodeItemType] = useState([]);// props.codeItemType;
    const [codeSession, setCodeSession] = useState([]);//[ {display: "No Session", value: -1}, ...props.codeSession];
    const [codeCouncil, setCodeCouncil] = useState([]);//[ {display: "No Council", value: -1}, ...props.codeCouncil];
    const [codeAuthor, setCodeAuthor] = useState([]);//[ {display: "No Authors", value: -1}, ...props.codeOfficial];
    const [codeCoAuthor, setCodeCoAuthor] = useState([]);//[{display: "No CoAuthors", value: -1}, ...props.codeOfficial];
    const [codeCategory, setCodeCategory] = useState([]);//[{display: "No Category", value: -1}, ...props.codeCategory];
    const [codeCommittee, setCodeCommittee] = useState([]);//[{display: "No Committee", value: -1}, ...props.codeCommittee];
    const [excerpt, setExcerpt] = useState(null);
    const [sending, setSending] = useState(false);
    const [successfulSave, setSuccessfulSave] = useState(false);
    const [errors, setErrors] = useState([]);
    const [warnings, setWarnings] = useState([]);
    const [saveModal, setSaveModal] = useState(false);
    const [photoPreview, setPhotoPreview] = useState([]);
    const [scannedPhoto, setScannedPhoto] = useState();
    const [uploadDoc, setUploadDoc] = useState(null);
    const [attachmentFile1, setAttachmentFile1] = useState(null);
    const [attachmentFile2, setAttachmentFile2] = useState(null);
    const [attachmentFile3, setAttachmentFile3] = useState(null);
    const [progressNum, setProgressNum] = useState(0);
    const [progressText, setProgressText] = useState("IDLE");
    const [sendingError, setSendingError] = useState("");
    const [formValues, setFormValues] = useState({
        ItemCode: "",
        Title: "",
        ItemType: -1,
        EnactedDate: "",
        ApprovedDate: "",
        Session: -1,
        Council: -1,
        Author: -1,
        CoAuthor: [],
        AuthorList: [],
        ItemContent: "",
        Committee: [],
        Category: [],
        DocEditorContent: "",
        Attachments: []
    });
    const inputDoc = useRef(null);
    const inputAttachment1 = useRef(null);
    const inputAttachment2 = useRef(null);
    const inputAttachment3 = useRef(null);
    const inputScan = useRef(null);
    const { Id } = useLoaderData();

    const [existingScanUrl, setExistingScanUrl] = useState("");
    const [existingDocUrl, setExistingDocUrl] = useState("");

    const [isLoading, setIsLoading] = useState(true);
    const [initialized, isInitialized] = useState(false);

    const [extractFrom, setExtractFrom] = useState("ocr");

    const [docOverwrite, setDocOverwrite] = useState(false);

    const [committeeOptions, setCommitteeOptions] = useState([]);

    useEffect(_ => {
        if (currentPdfPage <= 0 || currentPdfPage > numPages) {
            setCurrentPdfPage(1);
        }
    }, [currentPdfPage])

    //selection data initialization
    useEffect(_ => {
        axios.get(ajax_api + "items/GetOptions")
            .then(response => {
                return response.data
            })
            .then(d => {
                setCodeItemType(d.itemTypes)
                setCodeSession(d.sessions)
                setCodeCouncil(d.councils)
                setCodeAuthor(d.officials)
                setCodeCoAuthor(d.officials)
                setCodeCategory(d.categories)
                setCodeCommittee(d.committees)
                setCommitteeOptions(d.committees)
            })
            .catch(error => {
                console.log(error.response.data.error)
            })

        if (props.editMode) {
            axios.get(ajax_api + "items", {
                params: {
                    id: Id,
                    editMode: props.editMode
                },
                withCredentials: true
            })
                .then(r => {
                    return r.data;
                }).then(d => {
                    setIsLoading(false);
                    setExcerpt(d);
                }).catch(e => {
                    console.error(`ERROR (${e.code}): ${e.message}`);
                });
        } else {
            setExcerpt({});
            setIsLoading(false);
        }
        isInitialized(true);
        setErrors(["Error on getting data.."])
    }, []);

    useEffect(_ => {
        setCommitteeOptions((formValues.Council !== -1) ? codeCommittee.filter(c => c.councilIds.includes(Number(formValues.Council))) : codeCommittee)
    }, [formValues.Council])

    useEffect(_ => {
        if (excerpt != null && inputScan.current != null && inputDoc.current != null) {
            if (props.editMode) {
                setFormValues({
                    ...excerpt,
                    ItemScan: "",
                    FilePath: ""
                });
                //codeCommittee.forEach(c => {
                //    console.log("________________________")
                //    console.log(c.councilIds.includes(Number(excerpt.Council)));
                //    console.log(c.councilIds)
                //    console.log("________________________")
                //})
                setCommitteeOptions((excerpt.Council !== -1) ? codeCommittee.filter(c => c.councilIds.includes(Number(excerpt.Council))) : codeCommittee)
            }
            inputScan.current.value = "";
            inputDoc.current.value = "";

            var scanUrl = "";
            var docUrl = "";

            if (excerpt && excerpt.ItemScan) {
                var file = new Blob([s2ab(atob(excerpt.ItemScan))], { type: "image" }); // , { type: "application/pdf" }
                scanUrl = URL.createObjectURL(file);
                setExistingScanUrl(scanUrl);
                setPhotoPreview(scanUrl);
                // free memory when ever this component is unmounted
            }
            if (excerpt && excerpt.FilePath) {
                var file;
                //var file_ext = excerpt.DocumentFileName.split(".").pop();
                //if (file_ext == "xlsx" || file_ext == "xls") {
                file = new Blob([s2ab(atob(excerpt.FilePath))], { type: "" });
                //}// "document/"+}); // , { type: "application/pdf" }
                docUrl = URL.createObjectURL(file);
                setExistingDocUrl(docUrl);
                // free memory when ever this component is unmounted
            }
            return () => {
                URL.revokeObjectURL(scanUrl);
                URL.revokeObjectURL(docUrl);
            }
        }
    }, [excerpt]);

    const [pdfProcessing, setPdfProcessing] = useState(false);

    useEffect(_ => {
        if (scannedPhoto) {
            setPdfProcessing(false);
            let extension = scannedPhoto.name.split(".").pop();
            var objectUrl = "";


            if (extension != "pdf") {

                (async () => {
                    var _flag = await window.confirm("Overwrite Searchable text (Item Content) with text from OCR?");

                    if (_flag) setFormValues(f => ({ ...f, ItemContent: "" }));

                    var { data: { text } } = await ocr(scannedPhoto, m => {
                        setProgressNum(m.progress * 100);
                        setProgressText(m.status);
                    })
                    if (_flag) setFormValues(f => ({ ...f, ItemContent: text.replace(/\n/g, " ") }));
                })();


                //create the preview
                const objectUrl = URL.createObjectURL(scannedPhoto);
                setPhotoPreview(objectUrl);
            }

            // free memory when ever this component is unmounted
            return () => u => URL.revokeObjectURL(objectUrl);
        }
    }, [scannedPhoto]);


    const setErrorsWarns = _ => {
        //required
        var _errors = [];
        if (formValues.ItemType < 0) {
            _errors.push(<>No <b>Item Type</b> has been selected</>);
        }
        if (formValues.ItemCode === "") {
            _errors.push(<>No <b>Item Code</b> has been inputted</>);
        }
        if (formValues.Title === "") {
            _errors.push(<>No <b>Title</b> has been inputted</>);
        }
        //optional
        var _warn = [];
        if (formValues.ApprovedDate === "") {
            _warn.push(<><b>Approved Date</b> is blank. SP Item will be set to <i>Not approved</i></>);
        }
        if (formValues.EnactedDate === "") {
            _warn.push(<><b>Enacted Date</b> is blank. </>);
        }
        if (!props.editMode && uploadDoc === null) {
            _warn.push(<>No <b>Uploaded Document</b> File</>);
        }
        if (props.editMode && uploadDoc != null && excerpt.FilePath != "") {
            _warn.push(<><b>Uploaded Document</b> File will be overwritten</>);
        }
        if (formValues.Session === -1) {
            _warn.push(<>No <b>Session</b> selected</>);
        }
        if (formValues.Council === -1) {
            _warn.push(<>No <b>Council</b> selected</>);
        }
        if (formValues.Author === -1) {
            _warn.push(<>No <b>Author</b> selected</>);
        }
        if (formValues.CoAuthor.length === 0) {
            _warn.push(<>No <b>CoAuthor/s</b> selected</>);
        }
        if (formValues.AuthorList.length === 0) {
            _warn.push(<>No <b>CoAuthor/s</b> selected</>);
        }
        if (scannedPhoto === null) {
            _warn.push(<>No <b>Scanned Document</b> file</>);
        }
        if (formValues.ItemContent === "") {
            _warn.push(<>No <b>Content</b> inputted</>);
        }
        if (formValues.Category.length === 0) {
            _warn.push(<>Item is <i>not associated</i> to any <b>Category</b></>);
        }
        if (formValues.Committee.length === 0) {
            _warn.push(<>Item is not <i>associated</i> to any <b>Committee</b></>);
        }

        setErrors(_errors);
        setWarnings(_warn);
    }

    const saveItem = _ => {
        if (!sending) {
            setErrors([]);
            setSending(true);
            var form_data = new FormData();
            var arr_data = ["CoAuthor", "Category", "Committee", "AuthorList"];
            var int_data = ["Author", "Session", "Council", "Session"];
            var date_data = ["EnactedDate", "ApprovedDate"];

            for (var key in formValues) {
                if (arr_data.includes(key)) continue;
                else if (int_data.includes(key) && formValues[key] == null) {
                    form_data.append(key, -1);
                    continue;
                }
                else if (date_data.includes(key) && formValues[key] == null) {
                    form_data.append(key, "");
                    continue;
                }
                form_data.append(key, formValues[key]);
            }
            form_data.append("UploadDoc", uploadDoc);
            form_data.append("ScannedPhoto", scannedPhoto);

            arr_data.forEach(key => {
                if (formValues[key].length > 0) {
                    //form_data.append(key, JSON.stringify(formValues[key]));
                    formValues[key].forEach(val => form_data.append(key + '[]', val))
                }
            });

            var _attachments = [];
            form_data.append("Attachment1", attachmentFile1);
            form_data.append("Attachment2", attachmentFile2);
            form_data.append("Attachment3", attachmentFile3);
            formValues["Attachments"] = JSON.stringify(_attachments);

            //console.log(SAVE_URL)
            axios.post(
                SAVE_URL, form_data,
                {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        'Content-Type': 'multipart/form-data'
                    },
                    withCredentials: true
                }
            )
                .then(res => {
                    const { data } = res;
                    if (data.success) {
                        setSuccessfulSave(true);
                        navigate("/sp-items/view/" + data.id);
                    }
                    else {
                        setSending(false);
                        setSendingError(data.error);
                    }
                })
                .catch(function (error) {
                    // manipulate the error response here
                    var e = error.response.data;
                    setSending(false);
                    console.log(error);
                    setSendingError(e.substring(0, 150) + (e.length > 150 ? "..." : ""));
                });
        }
    }

    const selectStyles = {
        container: css => ({ ...css, width: '100px', minWidth: '100%' }),
    };
    const selectStylesBtn = {
        container: css => ({ ...css, width: '100px', minWidth: 'calc(100% - 100px)' }),
    };

    return <>
        <Helmet>
            <title>LTS | {props.editMode ? "Edit SP Item" : "Add New SP Item"}</title>
        </Helmet>
        <RagnaWindow
            minHeight={300}
            title={props.editMode ? "Edit Excerpt" : "Add New Excerpt"}
            footer={

                (
                    isLoading ? <></> :
                        <RagnaModal
                            syncFunction={setErrorsWarns}
                            trigName="Save"
                            title="Save Excerpt"
                            className={sending ? "saving-modal" : ""}
                            body={
                                <>
                                    {
                                        sending ? (
                                            successfulSave ? (
                                                <><i className="fa fa-save" /> Saved! Redirecting to Item Details..</>
                                            ) : (
                                                <div className="text-center"><i className="fa fa-cog fa-spin" variant="primary" /> Saving Data...</div>
                                            )
                                        )
                                            :
                                            sendingError != "" ?
                                                <div className="alert alert-danger">
                                                    <i className="fas fa-exclamation-triangle"></i> {sendingError}
                                                </div>
                                                : (
                                                    errors.length > 0 ?
                                                        <>
                                                            <div className="alert alert-danger">
                                                                <i className="fas fa-exclamation-triangle"></i> Required fields missing
                                                            </div>
                                                            <ul> {errors.map(e => <li>{e}</li>)} </ul>
                                                        </> :
                                                        <>
                                                            {
                                                                warnings.length > 0 ?
                                                                    <div className="alert alert-warning">
                                                                        <i className="fas fa-exclamation-triangle"></i> Fields that may need reviewing
                                                                    </div> : <>All data fields are filled up. Press Save to continue.</>
                                                            }
                                                            <ul> {warnings.map(e => <li>{e}</li>)}  </ul>
                                                        </>
                                                )
                                    }
                                </>
                            }
                            footer={
                                errors.length > 0 || sending ?
                                    null :
                                    <button className="ro-button mr-2" onClick={saveItem}>
                                        <span>Save</span>
                                    </button>
                            }
                            modalOpen={saveModal}
                            setModalOpen={setSaveModal} />
                )
            }
            footer_options={null}
            mainStyle={{ width: "100%", maxWidth: props.width ? props.width : "100%", transition: "all .1s" }}
            boxStyle={null}>
            {
                initialized ? (
                    isLoading ? <RagnaLoader /> : (
                        <RMultiTab linear={true} contents={
                            excerpt != null ?
                                [
                                    {
                                        title: <><i className="fa fa-list"></i> Item Details</>,
                                        content: <div className="addSPItemBox row">
                                            <div className="col-12 col-md-4">
                                                <div className="addItemTitle">Item Type: </div>
                                                <Select
                                                    styles={selectStyles}
                                                    value={codeItemType.filter(x => x.value == formValues.ItemType)}
                                                    onChange={e => setFormValues({ ...formValues, ItemType: e.value })}
                                                    options={codeItemType}
                                                />
                                                <div className="addItemTitle">Item Code:</div>
                                                <input className="form-control" onChange={e => setFormValues({ ...formValues, ItemCode: e.target.value })} value={formValues.ItemCode} />

                                            </div>
                                            <div className="col-12 col-md-8">
                                                <div className="row">
                                                    <div className="col-12 col-sm-6">
                                                        <div className="addItemTitle">Enacted Date:</div>
                                                        <RDatePicker limitYear={moment().format("YYYY")} yearRange={50} defaultValue={excerpt?.EnactedDate ?? null} selectedDate={formValues.EnactedDate} onChange={e => setFormValues({ ...formValues, EnactedDate: e === "" ? "" : moment(e).format("YYYY-MM-DD") })} />
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                        <div className="addItemTitle">Approved Date:</div>
                                                        <RDatePicker defaultValue={parseInt(moment(excerpt?.ApprovedDate).format("YYYY")) == 1 ? null : excerpt?.ApprovedDate ?? null} limitYear={moment().format("YYYY")} yearRange={50} selectedDate={formValues.ApprovedDate} onChange={e => setFormValues({ ...formValues, ApprovedDate: e === "" ? "" : moment(e).format("YYYY-MM-DD") })} />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="addItemTitle">Title:</div>
                                                    <textarea rows="3" className="form-control" onChange={e => setFormValues({ ...formValues, Title: e.target.value })} value={formValues.Title}></textarea>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 col-sm-6">
                                                        <div className="addItemTitle">Session:</div>
                                                        <Select
                                                            styles={selectStyles}
                                                            value={codeSession.filter(c => c.value == formValues.Session)}
                                                            onChange={e => setFormValues({ ...formValues, Session: e.value })}
                                                            options={codeSession}
                                                        />
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                        <div className="addItemTitle">Council:</div>
                                                        <Select
                                                            styles={selectStyles}
                                                            value={codeCouncil.filter(c => c.value == formValues.Council)}
                                                            onChange={e => setFormValues({ ...formValues, Council: e.value })}
                                                            options={codeCouncil}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    },
                                    {
                                        title: <><i className="fa fa-user"></i>  Author, CoAuthor/s</>,
                                        content: <>
                                            <div className="row">
                                                {/*<div className="d-none col-12 col-md-6">*/}
                                                {/*    <div className="addItemTitle">Author:</div>*/}
                                                {/*    <Select*/}
                                                {/*        styles={selectStyles}*/}
                                                {/*        value={codeAuthor.filter(c => c.value == formValues.Author)}*/}
                                                {/*        onChange={e => setFormValues({ ...formValues, Author: e.value })}*/}
                                                {/*        options={codeAuthor}*/}
                                                {/*    />*/}
                                                {/*</div>*/}
                                                <div className="col-12 col-md-6">
                                                    <div className="addItemTitle">Author:
                                                        <button className="ro-button add-coauthor-btn" onClick={_ => setFormValues({ ...formValues, AuthorList: [...formValues.AuthorList, -1] })}><span>Add Row</span></button>
                                                    </div>
                                                    {
                                                        formValues.AuthorList.length > 0 ?
                                                            formValues.AuthorList.map((_, i) => {
                                                                var coAuthor_arr = [...formValues.AuthorList];
                                                                return <div className="rem-coauthor-btn-cont" key={i}>
                                                                    <Select
                                                                        styles={selectStylesBtn}
                                                                        value={codeAuthor.filter(c => c.value == formValues.AuthorList[i])}
                                                                        onChange={e => {
                                                                            coAuthor_arr[i] = e.value;
                                                                            setFormValues({
                                                                                ...formValues, AuthorList: coAuthor_arr
                                                                            });
                                                                        }}
                                                                        options={
                                                                            (formValues.Council !== -1) ? codeAuthor.filter(c => formValues.AuthorList.includes(c.value + "") == false && formValues.CoAuthor.includes(c.value + "") == false && c.councilIds.includes(parseInt(formValues.Council))) : codeAuthor.filter(c => formValues.AuthorList.includes(c.value + "") == false && formValues.CoAuthor.includes(c.value + "") == false)
                                                                        }
                                                                    />
                                                                    <button className="ro-button ml-2" onClick={_ => setFormValues({ ...formValues, AuthorList: formValues.AuthorList.filter((_, ii) => ii != i) })}><span>Remove</span></button>

                                                                </div>
                                                            }) :
                                                            "No Authors"
                                                    }
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <div className="addItemTitle">CoAuthor/s:
                                                        <button className="ro-button add-coauthor-btn" onClick={_ => setFormValues({ ...formValues, CoAuthor: [...formValues.CoAuthor, -1] })}><span>Add Row</span></button>
                                                    </div>
                                                    {
                                                        formValues.CoAuthor.length > 0 ?
                                                            formValues.CoAuthor.map((_, i) => {
                                                                var coAuthor_arr = [...formValues.CoAuthor];
                                                                return <div className="rem-coauthor-btn-cont" key={i}>
                                                                    <Select
                                                                        styles={selectStylesBtn}
                                                                        value={codeCoAuthor.filter(c => c.value == formValues.CoAuthor[i])}
                                                                        onChange={e => {
                                                                            coAuthor_arr[i] = e.value;
                                                                            setFormValues({
                                                                                ...formValues, CoAuthor: coAuthor_arr
                                                                            });
                                                                        }} options={
                                                                            (formValues.Council !== -1) ? codeAuthor.filter(c => formValues.AuthorList.includes(c.value + "") == false && formValues.CoAuthor.includes(c.value + "") == false && c.councilIds.includes(parseInt(formValues.Council))) : codeAuthor.filter(c => formValues.AuthorList.includes(c.value + "") == false && formValues.CoAuthor.includes(c.value + "") == false)
                                                                        } />
                                                                    <button className="ro-button ml-2" onClick={_ => setFormValues({ ...formValues, CoAuthor: formValues.CoAuthor.filter((_, ii) => ii != i) })}><span>Remove</span></button>

                                                                </div>
                                                            }) :
                                                            "No CoAuthors"
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    },
                                    {
                                        title: <><i className="fa fa-users"></i> Category/s and Committee/s</>,
                                        content: <>
                                            <div className="row">
                                                <div className="col-12 col-md-6">
                                                    <div className="addItemTitle">Category/s:
                                                        <button className="ro-button add-coauthor-btn" onClick={_ => setFormValues({ ...formValues, Category: [...formValues.Category, -1] })}><span>Add Row</span></button>
                                                    </div>
                                                    {
                                                        formValues.Category.length > 0 ?
                                                            formValues.Category.map((_, i) => {
                                                                var cat_arr = [...formValues.Category];
                                                                return <div className="rem-coauthor-btn-cont" key={i}>
                                                                    <Select
                                                                        styles={selectStylesBtn}
                                                                        value={codeCategory.filter(c => c.value == formValues.Category[i])}
                                                                        onChange={e => {
                                                                            cat_arr[i] = e.value;
                                                                            setFormValues({ ...formValues, Category: cat_arr });
                                                                        }}
                                                                        options={codeCategory} />

                                                                    <button className="ro-button ml-2" onClick={_ => setFormValues({ ...formValues, Category: formValues.Category.filter((_, ii) => ii != i) })}><span>Remove</span></button>

                                                                </div>
                                                            }) :
                                                            "No Category"
                                                    }
                                                </div>

                                                <div className="col-12 col-md-6">
                                                    <div className="addItemTitle">Committee/s:
                                                        <button className="ro-button add-coauthor-btn" onClick={_ => setFormValues({ ...formValues, Committee: [...formValues.Committee, -1] })}><span>Add Row</span></button>
                                                    </div>
                                                    {
                                                        formValues.Committee.length > 0 ?
                                                            formValues.Committee.map((_, i) => {
                                                                var committee_arr = [...formValues.Committee];
                                                                return <div className="rem-coauthor-btn-cont" key={i}>
                                                                    <Select
                                                                        styles={selectStylesBtn}
                                                                        value={codeCommittee.filter(c => c.value == formValues.Committee[i])}
                                                                        onChange={e => {
                                                                            committee_arr[i] = e.value;
                                                                            setFormValues({ ...formValues, Committee: committee_arr });
                                                                        }}
                                                                        options={committeeOptions} />
                                                                    <button className="ro-button ml-2" onClick={_ => setFormValues({ ...formValues, Committee: formValues.Committee.filter((_, ii) => ii != i) })}><span>Remove</span></button>

                                                                </div>
                                                            }) :
                                                            "No Committee"
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    },
                                    {

                                        title: <><i className="fa fa-files"></i> File Attachments</>,
                                        content: <>
                                            <div className="addItemTitle">Document File:</div>
                                            {//disabled={excerpt.DocumentFileName == "disconnected"}
                                            }
                                            <input type="file" ref={inputDoc} onChange={e => setUploadDoc(e.target.files[0])} accept=".rtf,.pdf,.docx,application/msword" />
                                            {
                                                uploadDoc != null ?
                                                    <button className="ml-2 ro-button"
                                                        onClick={_ => {
                                                            inputDoc.current.value = "";
                                                            setUploadDoc(null);
                                                        }}
                                                    >
                                                        <span>Clear</span>
                                                    </button> : ""
                                            }
                                            {
                                                props.editMode && excerpt.FilePath ?
                                                    <div className="edit_file_validation">
                                                        <hr className='my-2' />
                                                        <div>Existing Document File: <a target="_blank" href={existingDocUrl} download={
                                                            canBeViewedWeb(excerpt.DocumentFileName.split(".").pop())
                                                                ? null : codeItemType.filter(c => c.value == excerpt.ItemType)[0].label + "-" + excerpt.ItemCode + "-Document." + excerpt.DocumentFileName.split(".").pop()
                                                        }><i className="fa fa-external-link"></i> {codeItemType.filter(c => c.value == excerpt.ItemType)[0].label + "-" + excerpt.ItemCode + "-Document." + excerpt.DocumentFileName.split(".").pop()}</a></div>
                                                        <div>Uploading another file will overwrite the existing one.</div>
                                                    </div>
                                                    : (

                                                        excerpt.DocumentFileName == "disconnected" ?
                                                            <div className="text-danger fw-bold"><i className="fa fa-exclamation-triangle" /> UNABLE TO CONNECT TO FTP SERVER. FILE/S ARE NOT AVAILABLE TO VIEW.</div>
                                                            : null
                                                    )
                                            }
                                            <div className="addItemTitle mt-4">Additional File Attachments:</div>
                                            <div>
                                                <input type="file" ref={inputAttachment1} onChange={e => setAttachmentFile1(e.target.files[0])} accept=".rtf,.pdf,.docx,application/msword" />
                                                {
                                                    attachmentFile1 != null ?
                                                        <button className="ml-2 ro-button"
                                                            onClick={_ => {
                                                                inputAttachment1.current.value = "";
                                                                setAttachmentFile1(null);
                                                            }}
                                                        >
                                                            <span>Clear</span>
                                                        </button> : ""
                                                }
                                            </div>
                                            <div className="mb-2">
                                                <input type="file" ref={inputAttachment2} onChange={e => setAttachmentFile2(e.target.files[0])} accept=".rtf,.pdf,.docx,application/msword" />
                                                {
                                                    attachmentFile2 != null ?
                                                        <button className="ml-2 ro-button"
                                                            onClick={_ => {
                                                                inputAttachment2.current.value = "";
                                                                setAttachmentFile2(null);
                                                            }}
                                                        >
                                                            <span>Clear</span>
                                                        </button> : ""
                                                }
                                            </div>
                                            <div>
                                                <input type="file" ref={inputAttachment3} onChange={e => setAttachmentFile3(e.target.files[0])} accept=".rtf,.pdf,.docx,application/msword" />
                                                {
                                                    attachmentFile3 != null ?
                                                        <button className="ml-2 ro-button"
                                                            onClick={_ => {
                                                                inputAttachment3.current.value = "";
                                                                setAttachmentFile3(null);
                                                            }}
                                                        >
                                                            <span>Clear</span>
                                                        </button> : ""
                                                }
                                            </div>
                                        </>
                                    },
                                    {
                                        title: <><i className="fa fa-search"></i> Searchable Text</>,
                                        content:
                                            <div className="addSPItemBox row">
                                                <div className="col-12">
                                                    <div className="addItemTitle">Content:</div>
                                                    <textarea disabled={pdfProcessing} rows="4" className="form-control" onChange={e => setFormValues({ ...formValues, ItemContent: e.target.value })} value={formValues.ItemContent}></textarea>
                                                </div>
                                                <div className="col-12">
                                                    <div style={{ fontWeight: 600 }}>
                                                        Extract text from:
                                                    </div>
                                                    <hr className="m-0 mt-1" />
                                                    <div className="d-flex">
                                                        <div className="form-check">
                                                            <input checked={extractFrom == "ocr"} onChange={_ => setExtractFrom("ocr")} className="form-check-input" type="radio" name="extract-from" id="ocrRadio" />
                                                            <label className="form-check-label" for="ocrRadio">
                                                                OCR Image file / PDF
                                                            </label>
                                                        </div>

                                                        <div className="form-check ms-5">
                                                            <input checked={extractFrom == "docEditor"} onChange={_ => setExtractFrom("docEditor")} className="form-check-input" type="radio" name="extract-from" id="docEditorRadio" />
                                                            <label className="form-check-label" for="docEditorRadio">
                                                                Document Editor
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    {
                                                        excerpt.ScannedFileName == "disconnected" ?
                                                            <div className="text-danger fw-bold"><i className="fa fa-exclamation-triangle" /> UNABLE TO CONNECT TO FTP SERVER. FILE/S ARE NOT AVAILABLE TO VIEW.</div>
                                                            : null
                                                    }
                                                    {
                                                        props.editMode && excerpt.ItemScan ? <div className="edit_file_validation">
                                                            <div>Existing Scanned File: <a target="_blank" href={existingScanUrl} download={
                                                                canBeViewedWeb(excerpt.ScannedFileName.split(".").pop())
                                                                    ? null : codeItemType.filter(c => c.value == excerpt.ItemType)[0].label + "-" + excerpt.ItemCode + "-Scanned." + excerpt.ScannedFileName.split(".").pop()
                                                            }><i className="fa fa-external-link"></i> {excerpt.ScannedFileName}</a></div>
                                                            <div>Uploading another file will overwrite the existing one.</div>
                                                            <hr className='my-2' />
                                                        </div> : null
                                                    }
                                                    {
                                                        extractFrom == "ocr" ?
                                                            <>
                                                                <input ref={inputScan} accept="image/*,application/pdf" type="file" onChange={e => setScannedPhoto(e.target.files[0])} />

                                                                <div className="progress ocr-progress position-relative mt-2 mx-3">
                                                                    <span>{`${progressNum == 0 ? "" : `${parseInt(progressNum)}%`} ${progressNum == 100 && progressText == "recognizing text" ? "DONE" : progressText}`}</span>
                                                                    <div className="progress-bar bg-success" style={{ width: `${progressNum}%` }} role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
                                                                </div>
                                                                {
                                                                    scannedPhoto != null ?
                                                                        (scannedPhoto.name.split(".").pop() == "pdf" ?
                                                                            (
                                                                                <>
                                                                                    {
                                                                                        //scanned document pagination navigation (?)
                                                                                        scannedPhoto != null ?
                                                                                            <div className='pt-2 text-center'>
                                                                                                {
                                                                                                    pdfProcessing ? "Processing " : <button
                                                                                                        disabled={currentPdfPage <= 1} className='btn btn-secondary' onClick={_ => setCurrentPdfPage(p => p == 1 ? 1 : p - 1)}>PREV</button>
                                                                                                }
                                                                                                <span className='mx-2'>
                                                                                                    Page {currentPdfPage} of {numPages}
                                                                                                </span>
                                                                                                {
                                                                                                    pdfProcessing ? "" : <button
                                                                                                        disabled={currentPdfPage >= numPages} className='btn btn-secondary' onClick={_ => setCurrentPdfPage(p => p >= numPages ? numPages : p + 1)}>NEXT</button>
                                                                                                }
                                                                                            </div> : <></>
                                                                                    }
                                                                                    <div className={`${pdfProcessing ? "" : "d-none"}`}>
                                                                                        OCR ongoing{(Array.apply(null, Array(3))).map(_ => <span>.</span>)}
                                                                                    </div>
                                                                                    <Document
                                                                                        onLoadError={console.error}
                                                                                        file={scannedPhoto}
                                                                                        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                                                                                        className={`import-pdf-page bg-secondary p-2 d-flex justify-content-center ${pdfProcessing ? "d-none" : ""}`}
                                                                                        style={{
                                                                                            background: '#ccc'
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            (Array.apply(null, Array(numPages))
                                                                                                .map((x, i) => i + 1))
                                                                                                .map(page => {
                                                                                                    return <>
                                                                                                        <Page onRenderSuccess={async () => {
                                                                                                            var _flag = formValues.ItemContent != "" ? window.confirm("Overwrite Searchable text (Item Content) with text from OCR?") : true;
                                                                                                            if (_flag) {
                                                                                                                if (page == numPages) {
                                                                                                                    setFormValues(f => ({ ...f, ItemContent: "" }));
                                                                                                                    for (let i = 1; i <= numPages; i++) {
                                                                                                                        setPdfProcessing(true);
                                                                                                                        const importPDFCanvas = document.querySelector(`.import-pdf-page > [data-page-number='${i}'] canvas`);
                                                                                                                        //const pdfAsImageSrc = importPDFCanvas.toDataURL();
                                                                                                                        setCurrentPdfPage(i);

                                                                                                                        var { data: { text } } = await ocr(importPDFCanvas, m => {
                                                                                                                            setProgressNum(m.progress * 100);
                                                                                                                            setProgressText(m.status);
                                                                                                                        });

                                                                                                                        setFormValues(f => ({ ...f, ItemContent: f.ItemContent + " " + text.replace(/\n/g, " ") }));

                                                                                                                        if (i == numPages) {
                                                                                                                            setPdfProcessing(false);
                                                                                                                            setCurrentPdfPage(1);
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }

                                                                                                        }} className={page != currentPdfPage ? "d-none" : ""} pageNumber={page} key={`scanned-page-${page}`} />
                                                                                                    </>
                                                                                                })

                                                                                        }
                                                                                    </Document>
                                                                                </>
                                                                            ) :
                                                                            <img src={photoPreview} alt={scannedPhoto ? scannedPhoto.name : "[ image preview ]"} />

                                                                        ) : <></>
                                                                }
                                                            </> :
                                                            <>
                                                                <label>
                                                                    <input onChange={_ => setDocOverwrite(d => !d)} checked={docOverwrite} type="checkbox" /> Overwrite Item Content?
                                                                </label>
                                                                <RichTextEditor
                                                                    initialValue={excerpt?.DocEditorContent ?? ""}
                                                                    onChange={
                                                                        (e, raw) => {
                                                                            if (docOverwrite)
                                                                                setFormValues(f => ({ ...f, ItemContent: raw, DocEditorContent: e }));
                                                                        }
                                                                    } />
                                                            </>
                                                    }
                                                </div>
                                            </div>
                                    }
                                ]
                                : []
                        } />
                    )
                ) : <RagnaLoader text="Getting selection data from server" />
            }
        </RagnaWindow>
    </>
}

export default SPItemAdd;